import moment from 'moment'

const Date = {
  install(Vue2) {
    Vue2.prototype.$date = {
      toMomentDateTimeFormat(date) {
        return `${this.toMomentDateFormat(date)}, ${this.toMomentTimeFormat(date)}`
      },

      toMomentDateFormat(date) {
        return moment(date).format(this.momentDateFormat())
      },

      toMomentTimeFormat(date) {
        return moment(date).format('h:mm a')
      },

      momentDateFormat() {
        return window.momentDateFormat
      },

      flatPickerDateTimeFormat(){
        return `${this.flatPickerDateFormat()} ${this.flatPickerTimeFormat()}`
      },

      flatPickerTimeFormat(){
        return 'h:i K'
      },

      flatPickerDateFormat(){
        return window.flatPickerDateFormat
      },

      isoFormat(){
        return 'Y-m-d H:i:S'
      },
    }
  },
}

export default Date
